export const UserUpdatePassword = {
	'Update your new password': 'Actualiza tu nueva contraseña',
	'You will receive in your email all the instructions to recover your password.':
		'Recibirás en tu correo electrónico todas las instrucciones para recuperar tu contraseña.',
	Password: 'Contraseña',
	'Confirm your password': 'Confirmar la contraseña',
	'Recover password': 'Recuperar contraseña',
	'Enter document number or email': 'Ingresa tú número de documento o email',
	'Back to home': 'Volver al inicio',
	'Reset Code': 'Código de recuperación',
	'Updating...': 'Actualizando...',
};
